export default {
    1: "1 удар",
    2: "3 удара",
    3: "6 ударов",
    4: "9 ударов",
    5: "12 ударов",
    6: "40 ударов"
};